// YERİ: src/app/domains/site/core/member-portal-url.ts
// Vitrindeki "Müşteri Girişi" bağlantısının TEK üretim noktası.
//
// ── NEDEN ŞİRKET GUID'İ ─────────────────────────────────────────────────────
// Bağlantı önceden /member/login?c={ClientId} idi. Client id'leri SIRALI:
// anonim bir ziyaretçi ?c=1,2,3… diye yürüyüp her kiracının marka adını ve
// slug'ını toplayabiliyordu.
//
// İlk çözümüm parametreyi üretimde hiç koymamak ve host'tan çözdürmekti; ama
// o zaman dev ve üretim AYRI yollardan gidiyordu — test ettiğim şey yayına
// çıkan şey değildi. ClientCompany.PublicUid (Guid) ikisini de çözer:
// tahmin edilemez ve her iki ortamda aynı çalışır.
//
// Ayrıca şirket kimliği taşıdığı için üye portalı O ŞİRKETİN giriş ekranını
// çizer; bir kiracının onlarca şirketi olabiliyor ve hepsi eskiden aynı
// ekranı gösteriyordu.
//
// Kendi `loginUrl`'ünü giren kiracı her durumda ezer.
import { isDevMode } from '@angular/core';

export function memberPortalUrl(companyUid: string | null | undefined, clientId = 0): string {
  const uid = (companyUid ?? '').trim();
  if (uid) return `/member/login?co=${encodeURIComponent(uid)}`;

  // Şirketsiz (kiracı kökü) site: üretimde parametresiz gider, portal kiracıyı
  // host'tan çözer. Dev'de host localhost olduğu için çözülemez — orada eski
  // id yolu yalnızca geliştirici kolaylığı olarak kalır (backend de bu yolu
  // yalnız Development'ta kabul ediyor).
  return isDevMode() && clientId > 0 ? `/member/login?c=${clientId}` : '/member/login';
}
